<template lang="pug">
.container-listagem
    el-row
      el-col
        el-button(type="text" icon="el-icon-arrow-left" @click="voltar") Voltar para painéis
        .container-titulo-painel
          h2 {{painel.nome}}
          span {{painel.descricao}}
        Pesquisa(
          placeHolder = "Informe o nome da demanda",
          @search="handlePesquisa"
          @resetSearch="resetPesquisa"
          :cardStyle="{margin:'0px 0px 10px 0px', 'border-radius':'12px'}"
          :hasPesquisaAvancada="true"
          @searchAdvanced="pesquisarAvancado"
          @setCardTitle="setTituloPesquisa"
        )
          template(slot="pesquisaAvancada")
            pesquisa-avancada-demandas(
              :painel="painel"
              :filtro="pesquisaAvancada"
            )
          template(slot="titulo")
            el-row
              el-col(:span="12")
                h2.titulo {{ tituloPesquisa }}
              el-col(:span="12").container-titulo-pesquisa
                el-popover(placement="left" title="Gerenciar time"  trigger="click")
                  el-select.input(
                    filterable
                    multiple
                    collapse-tags
                    :filter-method="filtrarUsuarios"
                    class="select"
                    @change="onTimeChange($event)"
                    v-model="time"
                    :loading="loadingTime"
                    placeholder="Selecione"
                    value-key="id"
                  )
                    el-option(
                      v-for="usuario in usuariosFiltrados",
                      :key="usuario.id",
                      :disabled="usuario.id === painel.criador.id"
                      :label="usuario.pessoa.nomeRazaoSocial",
                      :value="usuario"
                    )
                  el-button(slot="reference" type="success" icon="el-icon-plus") Gerenciar time

    el-card.default-card(shadow="hover")
      modal-cadastrar-demanda(
          v-if="modal"
          @closeModal="closeModal"
          @callbackSucesso="callbackModal"
          :idDemanda="idDemanda"
        )
      el-row.container(type="flex")
        h2.titulo Demandas do painel
        .button
          el-button(
          type="success",
          icon="el-icon-plus"
          @click="openModal"
          )
            span.center Cadastrar

      app-divider-refresh-button(
        label="Listagem de demandas",
        @click="getDemandas",
        :hasButton="true"
        content="Atualizar cadastros"
      )

      el-table.table(:data="painel.demandas" size="medium" @sort-change='sortChanged')
        template(slot="empty") Não há registros.
        el-table-column(
          prop='numeroDemanda'
          label='Nº',
          width="100"
          :formatter="Utils.formatEmptyRowNA"
          sortable='custom'
        )

        el-table-column(
          prop='nome'
          label='Nome da demanda',
          width="auto"
          :formatter="Utils.formatEmptyRowNA"
          sortable='custom'
        )

        el-table-column(
          prop='estadoDemanda.nome'
          label='Estado',
          width="auto"
          :formatter="Utils.formatEmptyRowNA"
          sortable='custom'
        )

        el-table-column(
          prop=''
          label='Progresso da atividade',
          width="auto"
        )
          template(slot-scope='scope')
            el-progress(v-if="scope.row.temAtividades" :text-inside="true" :stroke-width="20" :percentage="scope.row.porcentagemAtividadesCompletas" status='success')
            span(v-else) {{Utils.formatEmptyRowNA()}}

        el-table-column(
          prop='dataInicio'
          label='Data de início',
          width="auto"
        )
          template(slot-scope='scope')
            span(v-if="scope.row.dataInicio") {{scope.row.dataInicio}}
            span(v-else) -

        el-table-column(
          prop='dataEntrega'
          label='Data de entrega',
          width="auto"
        )
          template(slot-scope='scope')
            el-tag(:type="scope.row.dataEntregaJaPassou ? 'danger' : scope.row.demandaAVencer ? 'warning' : 'success'" effect='dark' size="medium") {{scope.row.dataEntrega}}

        el-table-column(
          prop='prioridade.nome'
          label='Prioridade',
          width="auto"
          sortable='custom'
        )
          template(slot-scope='scope')
            el-tag(v-if="scope.row.prioridade" :style="{'background-color':scope.row.prioridade.codigo, color: 'white', 'border': 'none'}" size="medium") {{scope.row.prioridade.nome}}
            span(v-else) {{Utils.formatEmptyRowNA()}}

        el-table-column(
          label='Responsável',
          width="auto",
          minWidth=120
        )
          template(slot-scope='scope')
            avatar-list(v-if="scope.row.responsaveis && scope.row.responsaveis.length > 0" :data="scope.row.responsaveis" label="pessoa.nomeRazaoSocial")
            span(v-else) {{Utils.formatEmptyRowNA()}}

        el-table-column(
          label='Ações',
          width="auto"
        )
          template(slot-scope='scope')
            button-acoes(:acoes="botoesAcao(scope.row)")
</template>

<script>
import Utils from '@/utils/utils'
import ButtonAcoes from '@/components/ButtonAcoes'
import AppDividerRefreshButton from '@/components/AppDividerRefreshButton'
import AvatarList from '@/components/AvatarList'
import ModalCadastrarDemanda from '@/screens/demandas/components/ModalCadastrarDemanda'
import Pesquisa from '@/components/Pesquisa'
import cloneDeep from 'lodash/cloneDeep'
import PesquisaAvancadaDemandas from '@/screens/demandas/components/PesquisaAvancadaDemandas'
import { mapActions } from 'vuex'
import AppNotificacao from '@/components/mixins/AppNotificacao'

const FILTRO_EMPTY = {}

const PESQUISA_AVANCADA_EMPTY = {
  idPainel: null,
  nome: null,
  responsavel: null,
  prioridade: null,
  estadoDemanda: null,
  periodoInicio: null,
  periodoEntrega: null
}
export default {
  async mounted () {
    this.setMainCardVisibility(false)
    await this.getDemandas()
    await this.getUsuarios()
    await this.getTime()
    await this.setSelectedUsersOnTop()
  },

  mixins: [
    AppNotificacao
  ],

  data () {
    return {
      modal: false,
      painel: {
        demandas: [],
        criador: {}
      },
      Utils,
      idDemanda: null,
      filtro: cloneDeep(FILTRO_EMPTY),
      pesquisaAvancada: cloneDeep(PESQUISA_AVANCADA_EMPTY),
      usuarios: [],
      usuariosFiltrados: [],
      time: [],
      ultimoTimeValido: [],
      loadingTime: false,
      tituloPesquisa: 'Pesquisa simplificada'
    }
  },

  methods: {
    ...mapActions({
      findPainelById: 'paineis/findById',
      findByFilter: 'demandas/findByFilter',
      setMainCardVisibility: 'userInterface/setMainCardVisibility',
      findUsuarios: 'paineis/findUsuarios',
      getTimeById: 'paineis/getTimeById',
      setTime: 'paineis/setTime',
      deleteDemanda: 'demandas/delete'
    }),

    voltar () {
      this.$router.go(-1)
    },

    resetPesquisa () {
      this.filtro = cloneDeep(FILTRO_EMPTY)
      this.pesquisaAvancada = cloneDeep(PESQUISA_AVANCADA_EMPTY)
      this.getDemandas()
    },

    handlePesquisa (pesquisaSimples) {
      this.pesquisar(pesquisaSimples)
    },

    closeModal () {
      this.modal = false
      this.getDemandas()
    },

    openModal () {
      this.idDemanda = null
      this.modal = true
    },

    callbackModal () {
      this.modal = false
    },

    getDemandas () {
      this.findPainelById(this.$route.query.idPainel).then((painel) => {
        this.painel = { ...this.painel, ...painel }
        this.pesquisar()
      })
    },

    editar (demanda) {
      this.idDemanda = demanda.id
      this.modal = true
    },

    async delete (demanda) {
      this.confirmBox('Você realmente deseja excluir a demanda? Após a exclusão, essa ação não pode ser desfeita.', this.$messages.TITULO_WARNING,
        async () => {
          await this.deleteDemanda(demanda.id).then(() => {
            this.showNotificacao(
              this.$messages.TIPO_SUCCESS,
              this.$messages.TITULO_SUCCESS,
              this.$messages.DEMANDA_EXCLUIDA_SUCESSO
            )
          })
          this.getDemandas()
        },
        () => { }, 'Confirmar', 'Cancelar')
    },

    botoesAcao (demanda) {
      return [
        {
          click: this.editar.bind(this, demanda),
          icon: 'edit',
          title: 'Editar demanda',
          active: true
        },
        {
          click: this.delete.bind(this, demanda),
          icon: 'delete',
          title: 'Excluir demanda',
          active: true
        }
      ]
    },

    getInicialPessoa (nome) {
      return nome.charAt(0).toUpperCase()
    },

    async pesquisar (pesquisaSimples) {
      this.setFiltroAdvancedSearch(pesquisaSimples)
      await this.findByFilter(this.filtro).then(data => {
        this.painel.demandas = data
      })

      this.filtro = cloneDeep(FILTRO_EMPTY)
    },

    async pesquisarAvancado () {
      this.setFiltroAdvancedSearch()
      await this.pesquisar()
    },

    setTituloPesquisa (tituloPesquisa) {
      this.tituloPesquisa = tituloPesquisa
    },

    setFiltroAdvancedSearch (pesquisaSimples) {
      this.filtro.nome = pesquisaSimples || this.pesquisaAvancada.nome

      if (this.pesquisaAvancada.responsavel) {
        this.filtro.idResponsavel = this.pesquisaAvancada.responsavel.id
      }

      if (this.pesquisaAvancada.prioridade) {
        this.filtro.idPrioridade = this.pesquisaAvancada.prioridade.id
      }

      if (this.pesquisaAvancada.estadoDemanda) {
        this.filtro.idEstado = this.pesquisaAvancada.estadoDemanda.id
      }

      if (this.pesquisaAvancada.periodoInicio) {
        this.filtro.dataInicio = this.pesquisaAvancada.periodoInicio[0]
        this.filtro.dataInicioFim = this.pesquisaAvancada.periodoInicio[1]
      }

      if (this.pesquisaAvancada.periodoEntrega) {
        this.filtro.dataEntrega = this.pesquisaAvancada.periodoEntrega[0]
        this.filtro.dataEntregaFim = this.pesquisaAvancada.periodoEntrega[1]
      }

      if (this.painel) {
        this.filtro.idPainel = this.painel.id
      }
    },

    async getUsuarios () {
      await this.findUsuarios().then((response) => {
        this.usuarios = response
        this.usuariosFiltrados = this.usuarios
      })
    },

    filtrarUsuarios (filterValue) {
      this.usuariosFiltrados = this.usuarios.filter(item => {
        return Utils.normalize(item.pessoa.nomeRazaoSocial).indexOf(Utils.normalize(filterValue)) > -1
      })
    },

    async getTime () {
      this.loadingTime = true
      this.time = await this.getTimeById(this.$route.query.idPainel)
      this.ultimoTimeValido = this.time
      this.loadingTime = false
    },

    async onTimeChange (time) {
      const criador = time.find((membro) => membro.id === this.painel.criador.id)

      if (!criador) {
        this.time = this.ultimoTimeValido
        this.showNotificacao(
          this.$messages.TIPO_WARNING,
          this.$messages.TITULO_WARNING,
          this.$messages.ERRO_EXCLUIR_CRIADOR_PAINEL
        )
      } else {
        this.loadingTime = true
        await this.setTime({ id: this.painel.id, time })
        this.pesquisar()
        this.ultimoTimeValido = this.time
        this.setSelectedUsersOnTop()
        this.loadingTime = false
      }
    },

    sortChanged ({ column, prop, order }) {
      const direcaoMap = {
        'ascending': 'ASC',
        'descending': 'DESC'
      }
      this.filtro.ordem = prop
      this.filtro.ordemDirecao = direcaoMap[order]
      this.pesquisar()
    },

    async setSelectedUsersOnTop () {
      let listAux = []
      await this.sortArrayTime()
      await this.time.reverse().forEach(async (usuarioTime) => {
        await this.usuariosFiltrados.forEach(async (userDaListaFiltrada, index) => {
          if (usuarioTime.id === userDaListaFiltrada.id) {
            listAux.push(index)
            let element = this.usuariosFiltrados[index]
            this.usuariosFiltrados.splice(index, 1)
            this.usuariosFiltrados.splice(0, 0, element)
          }
        })
      })
    },

    async sortArrayTime () {
      await this.time.sort(function (a, b) {
        if (a.pessoa.nomeRazaoSocial > b.pessoa.nomeRazaoSocial) {
          return 1
        }
        if (a.pessoa.nomeRazaoSocial < b.pessoa.nomeRazaoSocial) {
          return -1
        }
        return 0
      })
    }
  },

  components: {
    ButtonAcoes,
    AppDividerRefreshButton,
    AvatarList,
    ModalCadastrarDemanda,
    Pesquisa,
    PesquisaAvancadaDemandas
  }
}
</script>

<style lang="scss" scoped>
.container {
  justify-content: space-between;
  align-items: center;
}

>>> .el-badge__content {
  background-color: #4e5c6b;
}

.container-titulo-painel {
  padding-bottom: 40px;
}

.container-titulo-pesquisa {
  display: flex;
  padding-bottom: 30px;
  justify-content: flex-end;
}

.titulo {
  font-size: 20px;
  font-weight: bold;
}

>>> .el-progress-bar__innerText {
  color: black;
}

>>> .el-select__tags-text {
  overflow: auto;
  word-wrap: break-word;
  white-space: normal;
}

.el-select >>> .el-tag {
  height: 100%;
}

.el-select-dropdown {
  max-width: 2px;
}

.el-select-dropdown__item {
  height: 40px;
  padding-right: 40px;
}

>>> .el-card__body {
  .card-header-financeiro {
    display: none;
  }
}

@media screen and (max-width: 1010px) {
  >>> .el-tag {
    font-size: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/demandas/ListagemDemandas.vue